var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"container"}},[_c('div',{staticClass:"dot-typing"}),_c('p',{attrs:{"id":"text-load"}},[_vm._v(" Carregando ")])])])
}]

export { render, staticRenderFns }